export const transformPermissionObjectToArray = (obj: any) => {
  const resource = obj?.module?.value
  delete obj?.id
  delete obj?.support_id
  delete obj?.module
  if (obj?.can_read === null || obj?.can_read === false) {
    delete obj?.can_read
  } else if (obj?.can_create === null || obj?.can_create === false) {
    delete obj?.can_create
  } else if (obj?.can_update === null || obj?.can_update === false) {
    delete obj?.can_update
  } else if (obj?.can_delete === null || obj?.can_delete === false) {
    delete obj?.can_delete
  }
  const data = Object.entries(obj).map((o: any) => {
    let action_obj: any = {}
    if (o?.length % 2 === 0) {
      for (let i = 0; i < o.length; ) {
        action_obj[o[i]] = o[i + 1]
        i = i + 2
      }
    }
    let base_obj = {
      role: 'systemsupport',
      resource,
      action: action_obj?.can_read
        ? 'read:any'
        : action_obj?.can_create
        ? 'create:any'
        : action_obj?.can_update
        ? 'update:any'
        : action_obj?.can_delete
        ? 'delete:any'
        : '',
      attributes: '*',
    }
    return {
      ...base_obj,
    }
  })
  return data
}

export const transformOldNotification = (data: any[]) => {
  const transform = data?.map((d: any) => ({
    ...d,
    content: `${d?.title} - ${d?.description}`,
  }))
  return transform
}
